import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Row, Col } from 'react-materialize';
import * as actions from '../actions';


class Profile extends Component {
  // renderProfileInfo() {
  //   switch (this.props.auth) {
  //     case null:
  //       return;
  //     case false:
  //       return (
  //         <div>
  //           <a href="/auth/google">Please login here.</a>
  //         </div>
  //       );
  //     default:
  //       if (this.props.auth.subscription_id) {
  //         return (
  //           <ul>
  //             <li key="1">
  //               {this.props.auth.sites_available} sites available to add
  //             </li>
  //             <li key="2">
  //               <a href="/api/unsubscribe">Unsubscribe.</a>
  //             </li>
  //           </ul>
  //         );
  //       } else {
  //         return (
  //           <div>
  //             Please subscribe below:
  //             <PricingPlans />
  //           </div>
  //         );
  //       }
  //   }
  // }

  render() {
    const { unsubscribe } = this.props;
    const { subscription } = this.props.auth;

    return (
      <div>
        <Row><h3 className="col s12">Profile</h3></Row>
        <Row><p className="col s12">asdfasdfa</p></Row>
        <Row>
          <Col s={12}>
            <Link to="" className="unsubscribe-link" onClick={event => {
              event.preventDefault();
              unsubscribe(subscription);
            }}>Unsubscribe</Link>
          </Col>
        </Row>
        {/* <h3 className="row col s12">Profile</h3>
        <p className="row c">asdfasdfa</p> */}
        {/* {this.renderProfileInfo()} */}
      </div>
    );
  }
}

function mapStateToProps({ auth }) {
  return { auth };
}

export default connect(mapStateToProps, actions)(Profile);



// WEBPACK FOOTER //
// ./src/components/Profile.js